var _style, _rect, _g, _rect2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeFi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368.5 368.5",
    style: {
      enableBackground: "new 0 0 368.5 368.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DD007A;}\n\t.st1{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 368.5,
    height: 368.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.5,173c8,0,15.2,4.4,19,11.6h-38.3C158,177.4,165.4,173,173.5,173 M174.7,239.6c8.5,0.2,17.4-2,26.3-6 l0.4-0.2l-9.2-18.2l-0.2-0.3l-0.3,0.1c-4.5,2-9.1,3-13.6,3c-6.7,0-13.3-2.3-18.4-6.4c-0.1-0.1-1-0.9-1.2-1.1c-1-1-1.9-2-2.7-3.1 h62.4V196c0-25.8-19.6-45.9-44.7-45.9c-24.6,0-44.7,20-44.7,44.7c0,11.8,4.5,22.9,12.8,31.3l0.3,0.3c3.5,3.5,7.6,6.4,12,8.6 C156.6,236.1,162.8,239.3,174.7,239.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.2,210.4H55.8V168h14.4c16.3,0,23.3,6.4,23.3,21.2C93.5,204.1,86.5,210.4,70.2,210.4 M70.2,140.1H27.9v98.2 h42.3c31.6,0,51.1-18.8,51.1-49.1C121.3,158.9,101.7,140.1,70.2,140.1"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 312.7,
    y: 138.1,
    className: "st1",
    width: 27.9,
    height: 100.2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262,166.2h40.6v-27.6H262c-26.1,0-35.2,15.8-35.2,35.2v64.6h27.6v-28.8h38.8v-25.1h-38.8v-10.7 C254.4,169.5,257.8,166.2,262,166.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.7,98.4c-1.7-1.6-3.7-2-5.5-0.9l-50.8,35.2c-1.4,0.9-2.3,2.4-2.4,4.2c0,2.8,2.3,5.2,5.3,5.2 c0.4,0,0.9,0,1.3-0.1c0,0,41.8-9.1,49.5-11.2c1.1-0.3,2-0.7,2.9-2.1C205.8,120,203.2,101.8,199.7,98.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeFi);
export default __webpack_public_path__ + "static/media/DeFi.b53db610aad5af8de314f17ff109ff72.svg";
export { ForwardRef as ReactComponent };